import { useEffect, useState } from "react";
import { format } from "date-fns";
import { de } from "date-fns/locale";
import api from "./api";
import { RESERVATION_FILTERS, reservationQuery } from "./adminLogic";
import { Card, ChoiceButtons, Empty, PageTitle } from "./ui";

const ReservationCard = ({ reservation: r }) => {
    const date = new Date(r.datum);
    const name = `${r.vorname} ${r.nachname}`.trim();

    return (
        <Card className="grid grid-cols-[auto_1fr] items-start gap-x-4 gap-y-1">
            <div className="min-w-[56px] border-r border-forest/10 pr-4 text-center">
                <div className="text-[11px] font-semibold uppercase tracking-[.14em] text-messing">
                    {format(date, "EEEEEE", { locale: de })}
                </div>
                <div className="font-caslon text-[26px] leading-[1.1]">{format(date, "d")}</div>
                <div className="text-xs text-forest/55">{format(date, "MMM", { locale: de })}</div>
            </div>
            <div className="min-w-0">
                <div className="flex justify-between gap-3">
                    <div className="text-[17px]">{name}</div>
                    <div className="whitespace-nowrap text-[15px]">
                        {r.zeit} · {r.personen} P.
                    </div>
                </div>
                <div className="mt-1 break-words text-[13px] text-forest/60">
                    {r.telefon} · {r.email}
                </div>
                {r.kommentar && (
                    <div className="mt-2 whitespace-pre-line font-caslon text-sm italic">„{r.kommentar}“</div>
                )}
                <div className="mt-2.5 flex gap-4 text-[13px]">
                    <a href={`tel:${r.telefon}`} className="py-1.5 underline">
                        Anrufen
                    </a>
                    <a href={`mailto:${r.email}`} className="py-1.5 underline">
                        E-Mail
                    </a>
                </div>
            </div>
        </Card>
    );
};

export default function ReservationsPage() {
    const [filter, setFilter] = useState("woche");
    const [state, setState] = useState({ loading: true, items: [], error: false });

    useEffect(() => {
        let cancelled = false;
        setState((s) => ({ ...s, loading: true }));
        api.get("/reservation", { params: reservationQuery(filter) })
            .then((response) => !cancelled && setState({ loading: false, items: response.data, error: false }))
            .catch(() => !cancelled && setState({ loading: false, items: [], error: true }));
        return () => {
            cancelled = true;
        };
    }, [filter]);

    return (
        <div>
            <PageTitle>Reservierungen</PageTitle>
            <ChoiceButtons label="Zeitraum" options={RESERVATION_FILTERS} value={filter} onChange={setFilter} />
            <div className="grid gap-2.5">
                {state.items.map((r) => (
                    <ReservationCard key={r._id} reservation={r} />
                ))}
                {!state.loading && state.error && <Empty>Reservierungen konnten nicht geladen werden.</Empty>}
                {!state.loading && !state.error && state.items.length === 0 && (
                    <Empty>Keine Reservierungen in diesem Zeitraum.</Empty>
                )}
            </div>
        </div>
    );
}
